import React, { memo } from 'react';
import './payment-method.scss';
import { PAYMENT_METHOD } from '../../../../../utils/Utils';
import { withTranslation } from 'react-i18next';

const PaymentMethod = (props: any) => {
  const { isSubscriptionDonation, donation, stripeSubscriptionUrl, isFinishedSubsDonation, t } = props;

  const getPaymentMethod = () => {
    const method = donation?.payment_method || donation?.payment_method_code;
    const result = PAYMENT_METHOD.find((f: any) => f.code.toLowerCase() === method?.toLowerCase());
    if (result) {
      return t('language') === 'en' ? result.name.en : result.name.de;
    }
    return method;
  };

  return (
    <div className="payment-method">
      <div className="payment-method-container">
        <div className="donation-details-body bg-gray bg-linear">
          <div className="aw_container donation-details-body-container">
            <div className="donation-certificate">
              {isSubscriptionDonation(donation) && !isFinishedSubsDonation(donation) && (
                <>
                  <div className="donation-certificate-content-title" style={{ marginBottom: '10px' }}>
                    {t('payment_method')}
                  </div>
                  <div className="donation-certificate-section">
                    <div className="donation-certificate-field method-wrapper">
                      <div className="donation-certificate-field-title" style={{ marginRight: '10px' }}>
                        {getPaymentMethod()}
                        {donation?.last4 && String(donation.last4).trim() ? (
                          <span style={{ color: '#13735F' }}>
                            {' '}
                            - ●●●● <span>{String(donation.last4).trim()}</span>{' '}
                          </span>
                        ) : (
                          ''
                        )}
                      </div>
                      <a
                        className="p-button p-button-rounded wi-main-button wi-icon-edit"
                        href={stripeSubscriptionUrl}
                        target="_blank"
                        rel="noreferrer"
                        style={{ padding: '12px' }}
                      >
                        <i className="fa-solid fa-pencil" />
                      </a>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation('language')(memo(PaymentMethod));
